// Fragment "repeating site copy (BUG-025)" — the Story chapters / Approach pillars editor
// in admin/ContentAdmin.jsx. One `content_blocks` row per item field
// (`story.chapters.<i>.<field>`, cf. lib/siteContent.js SITE_REPEATERS), edited in the
// admin's current language only. Merged in ./index.js.
export default {
  fr: {
    "content.repeater.field.title": "Titre",
    "content.repeater.field.body": "Texte",
    "content.repeater.remove": "Supprimer",
    "content.repeater.moveUp": "Monter",
    "content.repeater.moveDown": "Descendre",
    "content.repeater.max": "Maximum : {max}",
    "content.repeater.langNote": "Vous modifiez la version {lang} ; l'autre langue est conservée telle quelle.",
    "content.repeater.story.chapters.label": "Mon parcours · Chapitres",
    "content.repeater.story.chapters.item": "Chapitre {n}",
    "content.repeater.story.chapters.add": "Ajouter un chapitre",
    "content.repeater.story.chapters.empty": "Aucun chapitre enregistré : votre site affiche les chapitres d'exemple. Ajoutez-en un pour écrire les vôtres.",
    "content.repeater.approach.pillars.label": "Mon approche · Cartes",
    "content.repeater.approach.pillars.item": "Carte {n}",
    "content.repeater.approach.pillars.add": "Ajouter une carte",
    "content.repeater.approach.pillars.empty": "Aucune carte enregistrée : votre site affiche les cartes d'exemple sous le titre « Mon approche ». Ajoutez-en une pour écrire les vôtres.",
  },
  en: {
    "content.repeater.field.title": "Title",
    "content.repeater.field.body": "Text",
    "content.repeater.remove": "Remove",
    "content.repeater.moveUp": "Move up",
    "content.repeater.moveDown": "Move down",
    "content.repeater.max": "Maximum: {max}",
    "content.repeater.langNote": "You are editing the {lang} version; the other language is left untouched.",
    "content.repeater.story.chapters.label": "My journey · Chapters",
    "content.repeater.story.chapters.item": "Chapter {n}",
    "content.repeater.story.chapters.add": "Add a chapter",
    "content.repeater.story.chapters.empty": "No chapter saved yet: your site is showing the sample chapters. Add one to write your own.",
    "content.repeater.approach.pillars.label": "My approach · Cards",
    "content.repeater.approach.pillars.item": "Card {n}",
    "content.repeater.approach.pillars.add": "Add a card",
    "content.repeater.approach.pillars.empty": "No card saved yet: your site is showing the sample cards under the “My approach” title. Add one to write your own.",
  },
  es: {
    "content.repeater.field.title": "Título",
    "content.repeater.field.body": "Texto",
    "content.repeater.remove": "Eliminar",
    "content.repeater.moveUp": "Subir",
    "content.repeater.moveDown": "Bajar",
    "content.repeater.max": "Máximo: {max}",
    "content.repeater.langNote": "Está editando la versión {lang}; el otro idioma se conserva intacto.",
    "content.repeater.story.chapters.label": "Mi trayectoria · Capítulos",
    "content.repeater.story.chapters.item": "Capítulo {n}",
    "content.repeater.story.chapters.add": "Añadir un capítulo",
    "content.repeater.story.chapters.empty": "Ningún capítulo guardado: su sitio muestra los capítulos de ejemplo. Añada uno para escribir los suyos.",
    "content.repeater.approach.pillars.label": "Mi enfoque · Tarjetas",
    "content.repeater.approach.pillars.item": "Tarjeta {n}",
    "content.repeater.approach.pillars.add": "Añadir una tarjeta",
    "content.repeater.approach.pillars.empty": "Ninguna tarjeta guardada: su sitio muestra las tarjetas de ejemplo bajo el título «Mi enfoque». Añada una para escribir las suyas.",
  },
};
